import {
    SET_LOADING,
    GET_DATA,
    GET_DATA_ERROR,
    CLEAR_DATA_ERROR,
    CLEAR_DATA,
    HIDE_DATA,
    SHOW_DATA

} from '../actions/actions.js'
import {
    DELETE_PREVIOUS_DATA,
    DELETE_PREVIOUS_DATA_ERROR,
    DELETE_PREVIOUS_FILTER,
    DELETE_PREVIOUS_FILTER_ERROR, DELETE_STATISTIC, DELETE_STATISTIC_ERROR,
    GET_LABELS,
    GET_LABELS_ERROR,
    GET_VALUES,
    GET_VALUES_ERROR,
    SET_ACTIVE_PLOT,
    SET_ACTIVE_PLOT_ERROR,
    SET_PREVIOUS_DATA,
    SET_PREVIOUS_DATA_ERROR,
    SET_PREVIOUS_FILTER,
    SET_PREVIOUS_FILTER_ERROR,
    SET_STATISTICS, SET_STATISTICS_ERROR,
    REMOVE_PLOT_POINT, HIDE_ALL_POINTS, SHOW_ALL_POINTS, GET_USER_DATA,
    REMOVE_USER_PLOT_POINT,
    GET_YEARLY_DATA,
    GET_YEARLY_DATA_ERROR,
} from "../actions/actions";

const initialState = {
    plot_data: [],
    loading: false,
    error: null,
    hide_data: {},
    labels: [],
    yearlyData:[],
    raport_values: [],
    active_plot: null,
    previous_data:{},
    user_plot_data: [],
    stats: {avg:false,
            sd:false,
            upperQuarter:false,
            lowerQuarter:false,
    },
    refresh: true
};
export default (state = initialState, action) => {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_USER_DATA:
            return {
                ...state,
                user_plot_data: action.payload,
                loading: false,
            };
        case GET_YEARLY_DATA:
            return {
                ...state,
                yearlyData: action.payload,
                loading: false,
            };
        case GET_DATA:
            return {
                ...state,
                plot_data: action.payload,
                hide_data: {...state.hide_data},
                loading: false,
            };
        case HIDE_DATA:
            let hide = state.hide_data;
            if (action.payload.name in hide){
                if(!hide[action.payload.name].includes(action.payload.data))
                    hide[action.payload.name].push(action.payload.data);

            }

            else{
                hide[action.payload.name] = [action.payload.data]
            }

            return {
                ...state,
                hide_data: hide,
                refresh: !state.refresh
            };
        case SHOW_DATA:
            let show = state.hide_data;
            if(action.payload.name in show){
                show[action.payload.name] = show[action.payload.name].filter((x) => x !== action.payload.data)
            }
            else{
                return {...state}
            }
            return {
                ...state,
                hide_data: show,
                 refresh: !state.refresh

            };
        case GET_DATA_ERROR:
            console.error(action.payload);
            return {
                ...state,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...state,
                plot_data: [],
                hide_data: {},
                loading: true,
            };
        case CLEAR_DATA_ERROR:
            console.error(action.payload);
            return {
                ...state,
            };
        case GET_LABELS:
            return {
                ...state,
                labels: action.payload
            };
        case GET_LABELS_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case GET_VALUES:
            return {
                ...state,
                raport_values: action.payload
            };
        case GET_VALUES_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case SET_ACTIVE_PLOT:
            return {
                ...state,
                active_plot: action.payload
            };
        case SET_ACTIVE_PLOT_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case SET_PREVIOUS_DATA:

            return {
                ...state,
                hide_data: Object.assign({...state.hide_data}, action.payload),
            };

        case SET_PREVIOUS_DATA_ERROR:
            console.error(action.payload);
            return {
                ...state,
                error: action.payload,
            };
        case DELETE_PREVIOUS_DATA:
            let tmp = {...state.previous_data};
            delete tmp[action.payload]
            return {
                ...state,
                previous_data: tmp,
            };
        case REMOVE_PLOT_POINT:
            let pointToRemove = {...state.plot_data};
            delete pointToRemove[action.payload]
            return {
                ...state,
                plot_data: pointToRemove,
            };

        case DELETE_PREVIOUS_DATA_ERROR:
            console.error(action.payload);
            return {
                ...state,
                error: action.payload,
            };
        case HIDE_ALL_POINTS:
            let hidePoints = state.hide_data;
            if (action.payload.name in hidePoints){
                action.payload.data.map(x =>{
                if(!hidePoints[action.payload.name].includes(x))

                    hidePoints[action.payload.name].push(x);
                }
            )
            }

            else{
                hidePoints[action.payload.name] = action.payload.data
            }

            return {
                ...state,
                hide_data: hidePoints,
                refresh: !state.refresh
            };
        case SHOW_ALL_POINTS:
            let showPoints =  state.hide_data;
            showPoints[action.payload.name]=[]
            return {
                ...state,
                hide_data: showPoints,
                refresh: !state.refresh
            };

        case SET_STATISTICS:
            return {
                ...state,
                stats: Object.assign({...state.stats}, action.payload),
            };

        case SET_STATISTICS_ERROR:
            console.error(action.payload);
            return {
                ...state,
                error: action.payload,
            };
        case DELETE_STATISTIC:
            return {
                ...state,
                stats: Object.assign({...state.stats}, action.payload),
            };

        case DELETE_STATISTIC_ERROR:
            console.error(action.payload);
            return {
                ...state,
                error: action.payload,
            };
        case REMOVE_USER_PLOT_POINT:
            let userPointToRemove = {...state.user_plot_data};
            delete userPointToRemove[action.payload]
            return {
                ...state,
                user_plot_data: userPointToRemove,
            };
        default:
            return state;
    }
};
